import styled, { css, keyframes } from 'styled-components';
import {
  v2Colors, v2FontFamily, v2ReadableFontFamily,
} from '../formInputsV2/styles/tokens';

const shimmer = keyframes`
  0% { transform: translateX(-100%); }
  55%, 100% { transform: translateX(100%); }
`;

export const ProgressWrap = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 0 auto 32px;
`;

export const ProgressMeta = styled.p`
  margin: 0 0 9px;
  font-family: ${v2ReadableFontFamily};
  font-size: 11.5px;
  font-weight: 700;
  letter-spacing: 0.09em;
  text-transform: uppercase;
  color: ${v2Colors.textFaint};
`;

export const SegmentTrack = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  min-height: 9px;
`;

export const Segment = styled.div`
  position: relative;
  flex: 1;
  height: 9px;
  border-radius: 999px;
  overflow: hidden;
  background: ${(props) => (
    props.$completed || props.$active ? v2Colors.primary : 'rgba(152, 162, 179, 0.25)'
  )};
  transition: background-color 200ms ease;

  ${(props) => props.$active && css`
    box-shadow: 0 2px 10px rgba(0, 166, 81, 0.35);

    &::after {
      content: '';
      position: absolute;
      inset: 0;
      background: linear-gradient(
        90deg,
        transparent 0%,
        rgba(255, 255, 255, 0.6) 50%,
        transparent 100%
      );
      transform: translateX(-100%);
      animation: ${shimmer} 1.9s ease-in-out infinite;
    }

    @media (prefers-reduced-motion: reduce) {
      &::after { animation: none; }
    }
  `}
`;

export const SegmentLabels = styled.div`
  display: flex;
  gap: 6px;
  margin-top: 11px;

  @media (max-width: 560px) {
    display: none;
  }
`;

export const SegmentLabel = styled.span`
  flex: 1;
  min-width: 0;
  font-family: ${v2FontFamily};
  font-size: 13px;
  font-weight: ${(props) => (props.$active || props.$completed ? 600 : 500)};
  letter-spacing: 0.01em;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${(props) => {
    if (props.$active) return v2Colors.text;
    if (props.$completed) return v2Colors.primary;
    return v2Colors.textMuted;
  }};
`;

export const ActiveStepText = styled.p`
  display: none;
  margin: 9px 0 0;
  font-family: ${v2FontFamily};
  font-size: 13.5px;
  font-weight: 600;
  color: ${v2Colors.text};

  @media (max-width: 560px) {
    display: block;
  }
`;
